// Trust stripe scroll animation — seamless loop + manual drag/swipe
(function() {
  function ensureSeamlessLoop(track, list) {
    if (!track || !list) return;
    var trackWidth = track.offsetWidth;
    var children = Array.from(list.children);
    children.forEach(function(child) {
      if (child.dataset.cloned) child.remove();
    });
    var originals = Array.from(list.children);
    if (!originals.length) return;
    var contentWidth = list.scrollWidth;
    while (contentWidth < trackWidth * 3) {
      originals.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.dataset.cloned = 'true';
        list.appendChild(clone);
      });
      contentWidth = list.scrollWidth;
    }
  }

  function enableDragScroll(track, list) {
    if (!track || !list) return;
    var isDragging = false;
    var startX = 0;
    var scrollOffset = 0;
    var currentOffset = 0;
    var resumeTimer = null;

    function getComputedTranslateX(el) {
      var style = window.getComputedStyle(el);
      var matrix = style.transform || style.webkitTransform;
      if (!matrix || matrix === 'none') return 0;
      var values = matrix.match(/matrix.*\((.+)\)/);
      if (!values) return 0;
      var parts = values[1].split(', ');
      return parseFloat(parts[4]) || 0;
    }

    function pauseAnimation() {
      clearTimeout(resumeTimer);
      currentOffset = getComputedTranslateX(list);
      list.style.animation = 'none';
      list.style.transform = 'translateX(' + currentOffset + 'px)';
    }

    function resumeAnimation() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function() {
        // Get where we left off as a percentage of half the scroll width
        var halfWidth = list.scrollWidth / 2;
        var normalizedOffset = ((currentOffset % halfWidth) + halfWidth) % halfWidth;
        var percentDone = normalizedOffset / halfWidth;

        // Remove inline styles to let CSS animation take over
        list.style.transform = '';
        list.style.animation = '';

        // Offset the animation to continue from current position
        var computedStyle = window.getComputedStyle(list);
        var duration = parseFloat(computedStyle.animationDuration) || 20;
        var delay = -(percentDone * duration);
        list.style.animationDelay = delay + 's';
      }, 1500);
    }

    // Mouse events
    track.addEventListener('mousedown', function(e) {
      isDragging = true;
      startX = e.pageX;
      pauseAnimation();
      scrollOffset = currentOffset;
      track.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      var dx = e.pageX - startX;
      currentOffset = scrollOffset + dx;
      list.style.transform = 'translateX(' + currentOffset + 'px)';
    });

    document.addEventListener('mouseup', function() {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      resumeAnimation();
    });

    // Touch events
    track.addEventListener('touchstart', function(e) {
      isDragging = true;
      startX = e.touches[0].pageX;
      pauseAnimation();
      scrollOffset = currentOffset;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var dx = e.touches[0].pageX - startX;
      currentOffset = scrollOffset + dx;
      list.style.transform = 'translateX(' + currentOffset + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function() {
      if (!isDragging) return;
      isDragging = false;
      resumeAnimation();
    });

    // Set grab cursor
    track.style.cursor = 'grab';
  }

  function initTrustStripes() {
    var stripes = document.querySelectorAll('.trust-stripe');
    stripes.forEach(function(stripe) {
      if (stripe.dataset.dragInit) return;
      stripe.dataset.dragInit = 'true';

      var logosTrack = stripe.querySelector('.trust-stripe__track');
      var logosList = stripe.querySelector('.trust-stripe__logos');
      ensureSeamlessLoop(logosTrack, logosList);
      enableDragScroll(logosTrack, logosList);

      var angelsTrack = stripe.querySelector('.trust-stripe__angels-track');
      var angelsList = stripe.querySelector('.trust-stripe__angels-list');
      ensureSeamlessLoop(angelsTrack, angelsList);
      enableDragScroll(angelsTrack, angelsList);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustStripes);
  } else {
    initTrustStripes();
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Re-clone on resize but don't re-init drag (already bound)
      var stripes = document.querySelectorAll('.trust-stripe');
      stripes.forEach(function(stripe) {
        var logosTrack = stripe.querySelector('.trust-stripe__track');
        var logosList = stripe.querySelector('.trust-stripe__logos');
        ensureSeamlessLoop(logosTrack, logosList);
        var angelsTrack = stripe.querySelector('.trust-stripe__angels-track');
        var angelsList = stripe.querySelector('.trust-stripe__angels-list');
        ensureSeamlessLoop(angelsTrack, angelsList);
      });
    }, 250);
  });
})();
